import React from 'react';
import '../../../assets/whypc/css/index.css';
import bootom from "../../../assets/whypc/image/bottom.png";
import beian from "../../../assets/whypc/image/beian.png";
import {Layout} from "antd";
const { Footer } = Layout;
class Footers extends React.Component {
    componentDidMount(){

    }
    feedBack = ()=>{

    }
    render() {

        return (  <Footer className="bootom">
                <div class="footertop">
                    <img style={{width:"100%"}} src={bootom} alt={bootom}/>
                </div>
                <div className="bootomss">
                    <div className="feet">
                        <p>联系电话：4008809382 |<a href="/#">服务条款</a> | <a href="/#"
                                                                               onClick={this.feedBack}> 意见反馈</a>
                        </p>
                        <p>
                            <a href="https://www.hnbxwhy.com/#/Xkz" target="_blank" rel="noopener noreferrer"> 增值电信业务经营许可证：豫B2-20130011
                                | </a>
                            <a href="http://video.hnbxwhy.com/9222976/wlwhjyxkz.png"
                               target="_blank" rel="noopener noreferrer">网络文化经营许可证：豫网文[2024]1532-018号</a>
                        </p>
                        <p>
                            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">ICP备案号：豫B2-20130011-4
                                Copyright &copy; 2014-2024
                                www.hnbxwhy.com 河南百姓文化云版权所有，未经授权禁止复制或镜像<img src={beian}
                                                                                                  alt="百姓文化云备案"/></a>
                        </p>
                        {/*<p>*/}
                        {/*    <a href="'http://video.hnbxwhy.com/9222976/wlwhjyxkz.png'"> 网络文化经营许可证：豫网文[2024]1532-018号</a></p>*/}
                        {/*<p>*/}
                        {/*    <a href="https://www.iyunshu.com/marketing.html?pageId=2307050005718383">*/}
                        {/*        <p className="beianwz" style={{padding_left: '26%', float: 'left'}}>*/}
                        {/*            增值电信业务经营许可证：豫网文[2024]1532-018号豫B2-20130011-4 | Copyright &copy; 2014-2024 www.hnbxwhy.com*/}
                        {/*            文化云*/}
                        {/*            版权所有，未经授权禁止复制或镜像*/}
                        {/*        </p></a>*/}
                        {/*    <a href="https://beian.miit.gov.cn/#/Integrated/index"> <img src={beian}*/}
                        {/*                                                                 alt="百姓文化云备案"/>*/}
                        {/*    </a>*/}
                        {/*</p>*/}
                    </div>


                </div>

            </Footer>
        )
    }
}
export default Footers;
